import React from "react";
import { Link } from "react-router-dom";
import ClotaLogoHD from "../../Images/av-logo.svg";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./Footer.css";
import WhatsApp from "./Whatsapp";
import { ScrollTop } from "primereact/scrolltop";

const Footer = () => {
  return (
    <>
    <WhatsApp />
    <div className="card flex flex-column align-items-center p-scrolltop">
        <ScrollTop />
      </div>
      

      <footer className="glass-footer mt-4 rounded shadow-3">
        <div className="footer-content">
          <div className="footer-boxN logo-box">
            <img src={ClotaLogoHD} alt="Clota Logo" className="footer-logo" />
            <p className="tagline footer-text">
              Empowering People
              <br/> Empowering Businesses
            </p>
          </div>

          <div className="footer-boxN">
            <h3>Help</h3>
            <Link to="/contactus" className="footer-linkN footer-text">
              Quick Connect
            </Link>
            <a href="tel:+919100030567" className="footer-linkN footer-text">
              Talk to Us
            </a>
          </div>

          <div className="footer-boxN">
            <h3>Contact</h3>
            <p className="footer-text">
              <FaPhoneAlt />
              <a href="tel:+919100030567" className="footer-text">
                +91 9100-030-567
              </a>
            </p>
            <p className="footer-text">
              <FaEnvelope />{" "}
              <a href="mailto:team@av-cs.in" className="footer-text">
                team@av-cs.in
              </a>
            </p>
            <p className="footer-text">
              <FaMapMarkerAlt /> Hyderabad, Telangana, India
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-text">© 2025 AV-CS |
            <a
              href="https://www.clotatech.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: '#fa821f' }}
            >
              <span>Powered by Clota Technology</span>
            </a>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
